import {
    ButtonIconTooltip,
    Dropdown,
    DropdownItemLink,
    DropdownMenuItem,
    HStack,
    memoWithType,
    PencilIcon,
    TrashIcon,
    useMobileView,
    useThreeDotsTrigger
} from "@hosttools/frontend";
import {useCallback} from "react";

type Props<T, ID> = {
    item: T;
    id: ID;
    onEdit?: (item: T, id: ID) => void;
    onRemove?: (id: ID) => void;
};

function TableCellEditRemoveActions<T, ID>({item, id, onEdit, onRemove}: Props<T, ID>) {
    const isMobile = useMobileView();
    const handleEdit = useCallback(() => {
        onEdit?.(item, id);
    }, [id, item, onEdit]);

    const handleRemove = useCallback(() => {
        onRemove?.(id);
    }, [id, onRemove]);

    const triggerListingDropdown = useThreeDotsTrigger({
        testID: "table-actions-dropdown"
    });

    if (isMobile) {
        return (
            <Dropdown placement="bottom right" trigger={triggerListingDropdown}>
                <DropdownMenuItem testID="dropdown-edit-item" onPress={handleEdit}>
                    <DropdownItemLink Icon={PencilIcon} label="Edit" />
                </DropdownMenuItem>
                {onRemove && (
                    <DropdownMenuItem testID="dropdown-delete-item" onPress={handleRemove}>
                        <DropdownItemLink Icon={TrashIcon} label="Delete" />
                    </DropdownMenuItem>
                )}
            </Dropdown>
        );
    }

    return (
        <HStack className="items-center" space="xs">
            {onEdit && (
                <ButtonIconTooltip
                    icon={PencilIcon}
                    testID="btn-icon-edit"
                    tooltip="Edit"
                    onPress={handleEdit}
                />
            )}
            {onRemove && (
                <ButtonIconTooltip
                    icon={TrashIcon}
                    testID="btn-icon-delete"
                    tooltip="Delete"
                    onPress={handleRemove}
                />
            )}
        </HStack>
    );
}

export default memoWithType(TableCellEditRemoveActions);
